import React, { ReactNode } from 'react';
import { Menu } from 'antd';
import './Navbar.less';

export type NavbarProps = {
  navigation?: {
    key: string;
    component?: ReactNode;
    icon?: ReactNode;
    content?: ReactNode;
    subMenu?: Array<{
      key: string;
      content: ReactNode;
    }>;
  }[];
  mode?: 'horizontal' | 'vertical' | 'inline';
  current: any;
  setCurrent?: (current: { current: string }) => void;
  onClick?: any;
  onOpenChange?: any;
  height?: string;
  theme?: 'dark' | 'light';
};

const TNavbar: React.FC<NavbarProps> = ({
  navigation,
  mode = 'vertical',
  current,
  setCurrent = () => {},
  onClick = () => {},
  onOpenChange,
  height,
  theme = 'light',
}) => {
  const itemClicked = (e) => {
    setCurrent(e.key);
    onClick(e);
  };
  function getSubMenu(navigation) {
    return navigation.map((item) => {
      if (item.component) {
        return item.component;
      } else if (item.subMenu) {
        const children = getSubMenu(item.subMenu);
        return (
          <Menu.SubMenu
            key={item.key}
            icon={item.icon}
            title={item.content}
            style={{ height: height, lineHeight: height }}
            popupClassName="t-popup-item"
          >
            {children}
          </Menu.SubMenu>
        );
      } else {
        return (
          <Menu.Item
            key={item.key}
            icon={item.icon}
            className="navMenuItem"
            style={{ height: height, lineHeight: height }}
          >
            {item.content}
          </Menu.Item>
        );
      }
    });
  }
  const menuItems: any = getSubMenu(navigation);

  return (
    <Menu
      className="t-navbar"
      onClick={itemClicked}
      onOpenChange={onOpenChange}
      mode={mode}
      selectedKeys={current}
      defaultOpenKeys={mode === 'inline' ? current : []}
      style={{ height: height, lineHeight: height }}
      forceSubMenuRender
      theme={theme}
    >
      {menuItems}
    </Menu>
  );
};

export default TNavbar;
